import { push } from "react-router-redux";

const redirectionMiddleware = store => next => action => {
  if (action.type === "REDIRECT" && action.redirectTo) {
    store.dispatch(push(action.redirectTo));
  }

  return next(action);
};

export default redirectionMiddleware;
